export default __webpack_public_path__ + "static/media/intro_to_arduino.8f99de8b.jpg";